import { styled } from 'styled-components';
import bannerImg from './banner.jpeg';

export const HomeBanner = styled.div`
  flex-grow: 1;
  background-image: url('${bannerImg}');
  background-size: cover;
`;

export const HomeBannerContent = styled.div`
  height: 100%;
  display: flex;
  flex-wrap: wrap;
  padding: 100px 0;
`;

export const HomeBannerInfo = styled.div`
  color: ${({ theme }) => theme.loginBannerInfo};
`;

export const HomeBannerInfoTitle = styled.h1`
  font-size: 96px;
  letter-spacing: -1.5px;
  text-transform: uppercase;
  font-weight: 800;
  margin: 0.67em 0px;
`;

export const HomeBannerInfoDescription = styled.p`
  font-size: 20px;
`;
